<script setup>
/**
 * FormControlModulestructureNumRows
 * Composition-based wrapper around the standard text form control.
 * Contextually exposes rows configuration rules when an entity type matches 'textarea',
 * sizing the element down to Bootstrap's grid span 4 layout automatically.
 */
import { onMounted, getCurrentInstance } from 'vue';
import FormControlTypeText from '../form-control-type/FormControlTypeText.vue';

const props = defineProps({
    // Standard Orchestrator Props
    formId: {
        type: String,
        required: true
    },
    field: {
        type: Object,
        required: true
    },
    currentData: {
        type: Object,
        required: true
    },
    value: {
        type: [String, Number, Array],
        default: null
    }
});

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- Lifecycle ---

onMounted(() => {
    if (!props.field || !props.currentData) return;

    if (props.currentData.type === 'textarea') {
        // Size the layout field component down to grid width 4
        props.field.size = 4;

        // TODO - This serves no purpose because the field will already have been saved before the type is set.
        // Once it's converted to a number field it can be removed anyway.
        store.dispatch(`${props.formId}/setDefaultValue`, {
            name: props.field.name,
            value: '0'
        });

    } else {
        // Hide the configuration row if the schema target isn't a long-form textarea
        props.field.hidden = true;
    }

    // TODO - Why is this field not a number field? I should check all sites and maybe convert.
});
</script>

<template>
    <FormControlTypeText
        v-if="!field.hidden"
        v-bind="$props"
        v-on="$listeners"
    />
</template>

<style scoped>
/* Grid formatting properties scale out of the base type wrapper */
</style>